import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  host: {
    '[class.responsive]': 'responsiveStyles',
  },
  selector: 'quant-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  /**
   * Allow for more responsive styles.
   * Eventually every modal should have this behavior but for now make it opt-in.
   */
  @Input() responsiveStyles = false;

  @Output() close = new EventEmitter<void>();

  constructor() {}

  closeModal(): void {
    this.close.emit();
  }
}
